import { Action } from "redux";

import {
  GET_OFFER_REQUEST_BY_ID,
  IS_LOADING_SAVE,
  IS_LOADING_SEND,
  GET_OFFER_REQUESTS,
  GET_OFFER_REQUEST_SENT,
} from "./types";

interface OfferRequestAction extends Action {
  payload: any;
}

const initialState = {
  loadingSave: false,
  loadingSend: false,
  currentOfferRequest: null,
  // Fresher copy of currentOfferRequest.offerRequestSent, reloaded after
  // sending without touching currentOfferRequest (which would reset the form).
  currentOfferRequestSent: null,
  offerRequests: [],
};

export default (state = initialState, action: OfferRequestAction) => {
  switch (action.type) {
    case GET_OFFER_REQUESTS:
      return {
        ...state,
        offerRequests: action.payload,
      };
    case IS_LOADING_SAVE:
      return {
        ...state,
        loadingSave: action.payload,
      };
    case IS_LOADING_SEND:
      return {
        ...state,
        loadingSend: action.payload,
      };
    case GET_OFFER_REQUEST_BY_ID:
      return {
        ...state,
        currentOfferRequest: action.payload,
        currentOfferRequestSent: null,
      };
    case GET_OFFER_REQUEST_SENT:
      return {
        ...state,
        currentOfferRequestSent: action.payload,
      };
    default:
      return state;
  }
};
